import React from "react"
import { injectIntl } from "react-intl"

import changePasswordFields  from "./fields/changePasswordFields"
import { DynamicForm } from "./../../../../../../components/partials/controls"

const ChangePasswordForm = (props) => {

  const { onSubmit, error, initialValues, saveRef, intl } = props

  const fields = changePasswordFields({ intl })

  return (
    <>
      <DynamicForm
        initialValues={initialValues}
        error={error}
        onSubmit={onSubmit}
        fields={fields}
      >
      <button ref={saveRef} className="d-none" type="submit"></button>
      </DynamicForm>
    </>
  )
}

export default injectIntl(ChangePasswordForm)
